<template>
  <div class="title-item">
    <div class="title-item-left">
      <slot />
    </div>
    <div v-if="rightIcon" class="title-item-right" @click="emit('change')">
      <slot name="right">
        <svg-icon icon="mingcute:settings-1-line" class="main-primary-text !w-[16px]" />管理
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SvgIcon } from '@vue3/components';

const emit = defineEmits(['change']);

defineProps({
  rightIcon: {
    type: Boolean,
    default: true,
  },
});
</script>

<style lang="scss" scoped>
.title-item {
  @apply w-full h-[30px] flex justify-between items-center;

  .title-item-left {
    @apply flex-1;
  }

  .title-item-right {
    @apply text-[14px] text-[#1777FF] cursor-pointer flex items-center gap-x-1;
  }
}
</style>
